export default __webpack_public_path__ + "static/media/ic_View_schedule.ffe62af2.svg";